import React from "react";
import { useLocation, useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex";
import LocationForm from "../LocationForm/LocationForm";
import { Location, ProjectVariable } from "../types/Location";

const FORM_ID = "location-form";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  locations: Location[];
  projectVariableDefinitions: ProjectVariable[];
}

const Edit: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  locations,
  projectVariableDefinitions,
}) => {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const location: Location = routeLocation.state?.location;
  const canSave = permission === "manage" && projectStatus === "building";

  return (
    <AdminFormPage
      title="Edit Location"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${projectId}/project_locations`, {
          state: null,
        })
      }
    >
      <LocationForm
        formId={FORM_ID}
        projectId={projectId}
        location={location}
        locations={locations}
        projectVariableDefinitions={projectVariableDefinitions}
      />
    </AdminFormPage>
  );
};

export default Edit;
